import { apiService } from 'core/services';
import type { TSliceExtraReducer } from 'core/store';
import { createAppAsyncThunk } from 'core/store/store.helpers';
import { SLICE_NAMESPACE } from '../../constants';
import { INavigationState } from '../../types';

export const fetchPriceGroups = createAppAsyncThunk(
  `${SLICE_NAMESPACE}/fetchPriceGroups`,
  async ({ navigationId }: { navigationId?: number }) => apiService.navigation.getNavigationPriceGroups(navigationId),
);

export const fetchPriceGroupsReducer: TSliceExtraReducer<INavigationState> = builder =>
  builder
    .addCase(fetchPriceGroups.pending, state => {
      state.options.priceGroups.loading = true;
      state.options.priceGroups.list = [];
    })
    .addCase(fetchPriceGroups.rejected, state => {
      state.options.priceGroups.loading = false;
      state.options.priceGroups.list = [];
    })
    .addCase(fetchPriceGroups.fulfilled, (state, action) => {
      state.options.priceGroups.loading = false;
      state.options.priceGroups.list = action.payload;
    });
